import React, { useState } from 'react';
import { ProSidebar } from "../../components/pro_calculator/general/ProSidebar";
import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

const FleetPlanningDashboard = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [cardRef, isCardVisible] = useScrollAnimation({ threshold: 0.2, triggerOnce: true });

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="flex min-h-screen">
      <ProSidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
      
      <main className={`flex-1 bg-gray-50 transition-all duration-300 ease-in-out ${collapsed ? "ml-[80px]" : "ml-[270px]"}`}>
        <div className="p-8 max-w-7xl mx-auto">
          <div
            ref={cardRef}
            className={`bg-white rounded-xl shadow-lg p-10 mt-[5vh] transition-all duration-1000 ease-out transform ${
              isCardVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            <h1 className="w-full text-center text-4xl font-bold text-gray-800 pb-6 font-nunito">
              Welcome to the AmpTrans Fleet Planner
            </h1>
            
            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-nunito">
              Your smart tool for evaluating the cost-effectiveness and logistics of transitioning your fleet to electric vehicles. Whether you're considering staying fully diesel, going partially electric, or making a full transition, AmpTrans helps you identify the most cost-effective path based on your unique operational data.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-nunito">
              Without a structured analysis, fleet transitions can lead to costly missteps — like investing in unnecessary vehicles, underestimating charging needs, or overlooking long-term savings. AmpTrans helps you avoid these pitfalls with confidence.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-nunito">
              Getting started is simple:
            </p>
            
            <ol className="list-decimal pl-6 mb-6 space-y-3 font-nunito text-lg text-gray-700 leading-relaxed">
              <li>Start by visiting the <strong>Inputs</strong> page and fill out your fleet's operational details. Your data is secure and will not be shared with anybody.</li>
              <li>After entering your inputs, you'll be prompted to run the optimization for your fleet. Our advanced <strong>spatial-temporal optimization model</strong> will handle everything, from financial insights to operational schedules.</li>
              <li>Check the <strong>Analytics</strong> page for detailed optimization results to help you make an informed decision about your transition.</li>
            </ol>

            <p className="text-lg text-gray-700 leading-relaxed pb-5 font-nunito">
              Our platform is continuously improving. If you have any questions or feedback, feel free to reach out to us at{' '}
              <a 
                href="mailto:info@amptrans.net"
                className="text-blue-600 font-medium transition-colors duration-200 hover:text-blue-700 hover:underline"
              >
                info@amptrans.net
              </a>, and stay tuned for upcoming updates.
            </p>
            
            <div className="mt-6 flex justify-center">
              <Link to="/inputs">
                <button className="btn-primary btn-lg font-nunito">
                  Get Started Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FleetPlanningDashboard;
